module.exports = __webpack_public_path__ + "static/media/16UNODC21.66841247.jpg";